// extracted by css-extract-rspack-plugin
export default {"cellSub":"cellSub-QJTw6m"};